export const createLifeCycleUpdater = (roomId, lifeCycleState) => {
  const { stage, step, acceptanceStatus } = lifeCycleState;

  return (rooms) => {
    const targetRoom = rooms.find((r) => r.id === roomId);

    if (!targetRoom) {
      return rooms;
    }

    const target = { ...targetRoom };

    target.stageAddressLifeCycle = stage;
    target.stepAddressLifeCycle = step;

    if (acceptanceStatus) {
      target.recordInfo = {
        ...target.recordInfo,
        acceptanceStatusAddressLifeCycle: acceptanceStatus,
      };
    } else {
      delete target.recordInfo?.acceptanceStatusAddressLifeCycle;
    }

    const relatedIds = target.relatedFlats
      ? new Set(target.relatedFlats.map((r) => r.id))
      : null;

    const { relatedFlats, ...restData } = target;

    return rooms.map((room) => {
      if (room.id === target.id) {
        return target;
      }

      if (relatedIds?.has(room.id)) {
        const newRoom = { ...room };

        newRoom.relatedFlats = room.relatedFlats.map((r) =>
          r.id === target.id ? { ...restData } : r
        );

        return newRoom;
      }

      return room;
    });
  };
};
